import React, {useRef, useState} from 'react';
import PropTypes from 'prop-types';
import styles from "./SearchDomainInput.scss";
import Submit from "./Submit";
import Button, {buttons} from "./Button";
import TextBox from "./TextBox";

const SearchDomainInput = (props) => {
	let {inputName, hasError, placeholder, customRef, defaultValue, onChange} = props;
	if (!customRef) {
		customRef = useRef(null);
	}
	if (!defaultValue) {
		defaultValue = '';
	}
	const [value, setValue] = useState(defaultValue);

	const onChangeInner = (event) => {

		setValue(event.target.value)

		if (typeof onChange === 'function') {
			onChange(event);
		}
	};
	const onClear = () => {
		customRef.current.value = '';
		customRef.current.focus();
		setValue('');
	};

	return (
		<div className={styles.container}>
			<Submit className={`${buttons.buttonImage} ${styles.submitButtonIcon}`} value={''}/>
			<TextBox
				customRef={customRef}
				type={"search"}
				name={inputName}
				hasError={hasError}
				placeholder={placeholder}
				autoComplete={'off'}
				defaultValue={defaultValue}
				onChange={onChangeInner}
				containerClass={styles.domainNameInput}/>
			{
				value !== '' &&
				<Button className={`${buttons.buttonImage} ${styles.clearFieldButton}`} value={''}
						onClick={onClear}/>
			}
		</div>
	);
};
SearchDomainInput.propTypes = {
	inputName: PropTypes.string.isRequired,
	hasError: PropTypes.bool,
	placeholder: PropTypes.string,
	defaultValue: PropTypes.string,
	onChange: PropTypes.func,
};
export default SearchDomainInput;


